import React, { useState, useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Col, Container, Row, Table } from "react-bootstrap";
import BlockTitle from "../../components/layout/blockTitle/BlockTitle";
import TitleWithIcon from "../../components/layout/pageTitle/PageTitle";
import { Button } from "../../components/ui";
import GetData from "../../services/getData";
import historyLogs from "../../media/history_transaction.png";

function Integrations() {
    const { t } = useTranslation("settings");
    const [loadingServices, setLoadingServices] = useState(false);
    const [loadingStaff, setLoadingStaff] = useState(false);
    const [message, setMessage] = useState({ text: "", isError: false });
    const [logs, setLogs] = useState([]);
    const [logsLoading, setLogsLoading] = useState(true);

    const loadLogs = useCallback(async () => {
        setLogsLoading(true);
        try {
            const data = await GetData({
                module: "settings",
                block: "integrations",
                action: "get_logs",
            });
            if (data && data.success === true && Array.isArray(data.logs)) {
                setLogs(data.logs);
            } else {
                setLogs([]);
            }
        } catch (err) {
            console.error("Ошибка загрузки логов:", err);
            setLogs([]);
        } finally {
            setLogsLoading(false);
        }
    }, []);

    useEffect(() => {
        loadLogs();
    }, [loadLogs]);

    const handleSyncServices = async () => {
        setLoadingServices(true);
        setMessage({ text: "", isError: false });
        try {
            const data = await GetData({
                module: "settings",
                block: "integrations",
                action: "sync_services",
            });
            if (data && data.success === true) {
                setMessage({ text: data.message || t("integrations.messages.servicesStarted"), isError: false });
                loadLogs();
            } else {
                setMessage({ text: (data && data.message) || t("integrations.errors.servicesSync"), isError: true });
            }
        } catch (err) {
            console.error("Ошибка:", err);
            setMessage({ text: t("integrations.errors.servicesFailed"), isError: true });
        } finally {
            setLoadingServices(false);
        }
    };

    const handleSyncStaff = async () => {
        setLoadingStaff(true);
        setMessage({ text: "", isError: false });
        try {
            const data = await GetData({
                module: "settings",
                block: "integrations",
                action: "sync_staff",
            });
            if (data && data.success === true) {
                setMessage({ text: data.message || t("integrations.messages.staffStarted"), isError: false });
            } else {
                setMessage({ text: (data && data.message) || t("integrations.errors.staffSync"), isError: true });
            }
        } catch (err) {
            console.error("Ошибка:", err);
            setMessage({ text: t("integrations.errors.staffFailed"), isError: true });
        } finally {
            setLoadingStaff(false);
        }
    };

    return (
        <Container fluid="md">
            <Row>
                <Col>
                    <BlockTitle
                        title={
                            <TitleWithIcon
                                icon={historyLogs}
                                title={t("integrations.title")}
                                showStatus={false}
                                status=""
                            />
                        }
                        buttons={[]}
                    />
                </Col>
            </Row>
            <Row>
                <Col>
                    <div className="page">
                        <div className="page-content">
                            <div className="page-block">
                                {message.text && (
                                    <div className={message.isError ? "text-danger" : "text-success"} style={{ marginBottom: "1rem" }}>
                                        {message.text}
                                    </div>
                                )}
                                <div style={{ display: "flex", gap: "1rem", flexWrap: "wrap" }}>
                                    <Button
                                        disabled={loadingServices}
                                        loading={loadingServices}
                                        onClick={handleSyncServices}
                                        variant="primary">
                                        {loadingServices ? t("integrations.running") : t("integrations.syncServices")}
                                    </Button>
                                    <Button
                                        disabled={loadingStaff}
                                        loading={loadingStaff}
                                        onClick={handleSyncStaff}
                                        variant="primary">
                                        {loadingStaff ? t("integrations.running") : t("integrations.syncStaff")}
                                    </Button>
                                </div>

                                <div className="page-block table-list" style={{ marginTop: "1.5rem" }}>
                                    <h6 style={{ marginBottom: "0.75rem" }}>{t("integrations.logTitle")}</h6>
                                    {logsLoading ? (
                                        <div>{t("state.loading", { ns: "common" })}</div>
                                    ) : logs.length === 0 ? (
                                        <div className="no-patients">{t("integrations.noRecords")}</div>
                                    ) : (
                                        <Table className="main-table-list rounded-table">
                                            <thead>
                                                <tr>
                                                    <th>{t("integrations.colType")}</th>
                                                    <th>{t("integrations.colMessage")}</th>
                                                    <th>{t("integrations.colDate")}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {logs.map((log) => (
                                                    <tr key={log.id}>
                                                        <td>{log.name}</td>
                                                        <td>{log.message}</td>
                                                        <td>{log.date || "—"}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>
        </Container>
    );
}

export default Integrations;
